import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/shared/ui/button"
import { GradientBorder } from "@/shared/components/GradientBorder"
import UploadFileIcon from "@/images/upload.png"
import DoneIcon from "@/images/SVG/doneIcon.svg"
import Loader from '@/shared/components/Loader'

export function CreateTemplateUploadZone({
  file,
  submitting,
  fileInputRef,
  onDrop,
  onDragOver,
  onBrowse,
  onFileChange,
}) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      <div
        className={`flex flex-col items-center justify-center w-full border border-[#E4E4E7] p-5 rounded-xl ${submitting ? 'opacity-80 cursor-not-allowed' : ''}`}
        onDrop={onDrop}
        onDragOver={onDragOver}
        onClick={submitting ? undefined : onBrowse}
        role="button"
        tabIndex={0}
      >
        <GradientBorder>
          <div className="shadow-sm bg-white rounded-full px-4 py-4">
            {submitting ? (
              <div className="w-6 h-6 flex items-center justify-center">
                <Loader />
              </div>
            ) : (
              <img
                width={'24px'}
                src={file ? DoneIcon : UploadFileIcon}
                alt="upload file"
              />
            )}
          </div>
        </GradientBorder>
        <h1 className="font-medium mt-[16px] md:text-[20px] text-lg">
          {submitting
            ? t("profile.templates.create.pleaseWaitGenerating")
            : (file ? t("reports.generate.file.selected") : t("reports.generate.file.choose"))
          }
        </h1>
        <div className="mt-[16px]">
          {file ? (
            <p className="text-xs text-[#71717a] text-center">
              {file.name} ({Math.round(file.size / 1024)} KB)
            </p>
          ) : (
            <Button type="button" variant="outline" onClick={(e) => { e.stopPropagation(); onBrowse(); }}>
              {t("reports.generate.file.browse")}
            </Button>
          )}
        </div>
        <input
          ref={fileInputRef}
          type="file"
          accept="application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.docx"
          onChange={onFileChange}
          className="hidden"
        />
      </div>
    </div>
  );
}
